var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStore = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 2.25A3.75 3.75 0 0 0 4.25 6v.25H3a.75.75 0 0 0-.741.864l1 6.5A.75.75 0 0 0 4 14.25h8a.75.75 0 0 0 .741-.636l1-6.5A.75.75 0 0 0 13 6.25h-1.25V6A3.75 3.75 0 0 0 8 2.25zm2.25 4V6a2.25 2.25 0 0 0-4.5 0v.25h4.5zm-5.607 6.5-.769-5h8.252l-.77 5H4.644z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStore);
export default ForwardRef;